module.exports = __webpack_public_path__ + "static/react-96a99d335de93d957cc594a0f6cf65d3.svg";